const handleTimedMetadata = (timedMetadata, propertyName, callback) => {
  if (timedMetadata === null) return
  if (!timedMetadata.hasOwnProperty(propertyName)) return
  callback(timedMetadata[propertyName])
}

export default handleTimedMetadata